import React from 'react'
import { Dialog, DialogContent, Grid, makeStyles } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { CloseModalIcon } from './Icons/index'
import { isMobile } from 'react-device-detect'

const useStyles = makeStyles({
  expandModal: {
    width: '100vw',
    height: '100vh',
    padding: 50,
    '& .MuiDialog-paperScrollPaper': {
      maxWidth: 'unset',
      width: '100%',
      height: '100%',
    },
    '& .MuiGrid-container': {
      height: '100%',
    },
    '& .MuiDialogContent-root': {
      padding: '25px',
    },
  },
  expandModalMobile: {
    width: '100vw',
    height: '100vh',
    padding: 2,
    '& .MuiDialog-paperScrollPaper': {
      maxWidth: 'unset',
      width: '100%',
      height: '80%',
      margin: '2px !important',
    },
    '& .MuiGrid-container': {
      height: '100%',
    },
    '& .MuiDialogContent-root': {
      padding: '25px',
    },
  },
  collapseModalMobile: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: 'rgba(255,255,255,0.15)',
    position: 'fixed',
    top: 40,
    right: 0,
    zIndex: 1301,
    '& img': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      cursor: 'pointer',
    },
    '& svg': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      cursor: 'pointer',
      color: '#fff',
    },
  },
  collapseModal: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: 'rgba(255,255,255,0.15)',
    position: 'fixed',
    top: 40,
    right: 40,
    zIndex: 1301,
    '& img': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      cursor: 'pointer',
    },
    '& svg': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      cursor: 'pointer',
      color: '#fff',
    },
  },
})

const ChartDialog = ({chart, isOpenExpandModal, setOpenExpandModal}) => {
  const classes = useStyles()
  return (
    <>
      <Dialog
        className={isMobile ? classes.expandModalMobile : classes.expandModal}
        open={isOpenExpandModal}
        onClose={() => setOpenExpandModal(false)}
        aria-labelledby="ChartDialog-title"
        aria-describedby="ChartDialog-description"
      >
        <DialogContent>
          <Grid className={classes.marketContextContainer} container>
            {chart}
          </Grid>
        </DialogContent>
      </Dialog>
      {isOpenExpandModal && <div className={isMobile ? classes.collapseModalMobile : classes.collapseModal} onClick={() => setOpenExpandModal(false)}>
        <CloseModalIcon />
      </div>}
    </>
  )
}

export default ChartDialog